export default __webpack_public_path__ + "static/media/author-9.48173003.png";